module.exports = __webpack_public_path__ + "static/media/consultation-block-fallback.7d3c8941.png";